'use client';

import { cn } from '@baseball-near-you/ui';
import { useSearchParams } from 'next/navigation';

export function Messages() {
  const searchParams = useSearchParams();
  const error = searchParams.get('error');
  const message = searchParams.get('message');
  return error || message ? (
    <div
      className={cn(
        'title rounded-md p-4 text-center shadow-xs',
        error
          ? 'bg-red/[14%] text-black'
          : 'whitespace-nowrap bg-green-600/[75%] px-4 py-7 text-lg text-white shadow-md'
      )}
    >
      {!!(error || message) && <p>{error || message}</p>}
    </div>
  ) : null;
}
